<template>
    <div>
        <div class="row">
            <div class="col-md-3">
                <card v-if="tree">
                    <collapse :multiple-active="false" :active-index="0">
                        <collapse-item :title="`Volume ${vol.volume}`" v-for="(vol) in tree" :key="`vol${vol.volume}`">
                            <ul class="issues-list">
                                <!-- <router-link class="nav-item" tag="li" :to="`/www/glimpses/home/${vol.volume}/${issue}`" v-for="(issue) in vol.issues" :key="`vol${vol.volume}issue${issue}`"> -->
                                    <a class="nav-link" :href="`/www/glimpses/home/${vol.volume}/${issue}`" v-for="(issue) in vol.issues" :key="`vol${vol.volume}issue${issue}`">Issue {{ issue }}</a>
                                <!-- </router-link> -->
                            </ul>
                        </collapse-item>
                    </collapse>
                </card>
            </div>
            <div class="col-md-9">
                <card card-body-classes="" no-footer-line v-if="newsletter">
                    <div slot="header">
                        <h4  class="title title-up mb-0">
                        Glimpses Volume: {{ newsletter.volume }} | Issue: {{ newsletter.issue }}
                        </h4>
                        <p class="text-muted">{{ date }}</p>
                    </div>
                    <div class="row">
                        <div class="col-12 mt-2">
                            <NewsCard 
                                type="main"
                                :news="newsletter.featured_news"
                                @card-click="openNews"
                            ></NewsCard>
                            <NewsCard 
                                v-for="(item, index) in newsletter.news"
                                :key="index"
                                type="sub"
                                :news="item"
                                @card-click="openNews"
                            ></NewsCard>
                        </div>
                    </div>
                </card>
            </div>
        </div>
    </div>
</template>

<script>
import { Card, NewsCard, PreviewCard, NewsletterCard, Collapse, CollapseItem } from 'src/components';
import { mapGetters } from 'vuex';

export default {
    name: 'Home',
    components:{
        Card,
        PreviewCard,
        NewsCard,
        NewsletterCard,
        Collapse,
        CollapseItem
    },
    data(){
        return {
            // volumes: [
            //     {
            //         number: 1,
            //         issues: [1, 2, 3, 4, 5, 6]
            //     },
            //     {
            //         number: 2,
            //         issues: [1, 2, 3, 4, 5, 6]
            //     }
            // ]
        }
    },
    mounted(){
        this.$store.dispatch('getNewsletterTree')
        let volume = 1
        let issue = 1

        if(this.$route.params.volume && this.$route.params.issue){
            volume = this.$route.params.volume
            issue = this.$route.params.issue
        }

        this.$store.dispatch('getNewsletterByVolumeIssue', { volume, issue })
    },
    computed: {
        ...mapGetters({
            authTokens: 'getAuthTokens',
            newsletter: 'getNewsletter',
            tree: 'getNewsletterTree'
        }),
        date: function(){
            if(this.newsletter){
                let date = new Date(this.newsletter.date)
                return date.toLocaleString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
            }
            else{
                return ''
            }
        },
    },
    methods: {
        openNews(news){
            this.$router.push(`/www/glimpses/news/${news.slug}`)
        }
    }
}
</script>

<style lang="scss">
    .issues-list{
        list-style-type: none;
        padding-left: 0;
    }
</style>
